import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ElasticSearchService } from '../shared/search-elasticsearch.service';
import { SearchService } from '../shared/search.service';
import { UtilsService } from '../shared/utils.service';
import { isBrowser } from 'angular2-universal';
//<span *ngIf="utils.isInEsFilters(esFilters, agg.key, term.key)">{{term.key}}</span>
@Component({
  selector: 'search-az',
  template: require('./partials/search-az.html')
})
export class SearchAZComponent implements OnInit {

  @Output() onFilter: EventEmitter<Object> = new EventEmitter<Object>();
  @Input() labels: any;
  @Input() language: string;
  @Input() title: string;
  @Input() target: string;
  query: Object;
  aggs: Object;
  azData: Object = {};
  fields = ['soloist', 'composer', 'conductor']; // , 'orchestra.fr'
  requestType: string;
  ready: boolean = false;

  constructor(private searchService: SearchService, private elementRef: ElementRef, private utils: UtilsService, private route: ActivatedRoute, private router: Router, private es: ElasticSearchService) { }

  ngOnInit() {
    // Build query
    this.query = this.es.query_search_all_nosort;
    this.query['aggregations'] = this.es.buildQuery_agg(this.fields, 10000);
    for(let type of Object.keys(this.query['aggregations'])){
      this.query['aggregations'][type]['terms']['order'] = {_term: 'asc'};
    }
    this.query['size'] = 0;

    // JS file path must be configurable
    if (isBrowser) {
      this.utils.loadScripts(["/resources_front/assets/custom/popup-gallery-bundle.js"], this.elementRef.nativeElement);
    }
  }

  onClickLoad(type: string){
    this.requestType = type;
    this.searchService.search('record', this.query)
      .then(response => {
        this.aggs = JSON.parse(response.body)['aggregations'];
        this.azify(this.aggs);
        this.ready = true;
      });
  }

  azify(data: Object){
    for(let type of Object.keys(data)){
      let typeSafe = type.replace(/\./,"_DOT_");
      this.azData[typeSafe] = {};
      for(let e of data[type].buckets){
        let name = e.key.replace(/^ +/,"");
        let letter = name.substring(0,1).toLowerCase();
        if(!this.azData[typeSafe][letter])
          this.azData[typeSafe][letter] = [];
        this.azData[typeSafe][letter].push(name);
      }
    }
  }

  onSelect(type: string, value: string) {
    // Restore actual value for type
    type = type.replace(/_DOT_/,".");
    // Callback 
    this.onFilter.emit({ type: type, value: value });
    // Nav (new search)
    let newQueryParams = { queryParams: {} };
    newQueryParams.queryParams['f'] = this.utils.appendQueryParam('', type, value);
    newQueryParams['relativeTo'] = this.route.parent;

    this.router.navigate([this.target], newQueryParams);

    if(isBrowser) {
      //setTimeout(() => window.scrollTo(0, this.utils.getElementPosition('#content-start', 20, -20)), 1000);
      setTimeout(() => window.scrollTo(0, 0), 1000);
    }
    
  }

  

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/search-az.component.ts